module.exports = __webpack_public_path__ + "img/base_activites_saut_elastique.623bb887.svg";